import React, { useEffect } from "react";

//  basename="/promo" debug={isDev}

function Analytics({ basename, local = false, children }) {
  useEffect(() => {
    if (!local) {
      window.gtag("event", "page_view", {
        page_path: basename + window.location.pathname + window.location.search,
        page_search: window.location.search,
      });
    }
  }, [window.location]);

  return <React.Fragment>{children}</React.Fragment>;
}

export default Analytics;
